"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodyPart = void 0;
/**
 * Different parts of the body. Maps to each possible non-tracker bone in the skeleton.
 * These are *NOT* the trackers.
 */
var BodyPart;
(function (BodyPart) {
    BodyPart[BodyPart["NONE"] = 0] = "NONE";
    BodyPart[BodyPart["HEAD"] = 1] = "HEAD";
    BodyPart[BodyPart["NECK"] = 2] = "NECK";
    BodyPart[BodyPart["CHEST"] = 3] = "CHEST";
    BodyPart[BodyPart["WAIST"] = 4] = "WAIST";
    BodyPart[BodyPart["HIP"] = 5] = "HIP";
    BodyPart[BodyPart["LEFT_UPPER_LEG"] = 6] = "LEFT_UPPER_LEG";
    BodyPart[BodyPart["RIGHT_UPPER_LEG"] = 7] = "RIGHT_UPPER_LEG";
    BodyPart[BodyPart["LEFT_LOWER_LEG"] = 8] = "LEFT_LOWER_LEG";
    BodyPart[BodyPart["RIGHT_LOWER_LEG"] = 9] = "RIGHT_LOWER_LEG";
    BodyPart[BodyPart["LEFT_FOOT"] = 10] = "LEFT_FOOT";
    BodyPart[BodyPart["RIGHT_FOOT"] = 11] = "RIGHT_FOOT";
    BodyPart[BodyPart["LEFT_LOWER_ARM"] = 14] = "LEFT_LOWER_ARM";
    BodyPart[BodyPart["RIGHT_LOWER_ARM"] = 15] = "RIGHT_LOWER_ARM";
    BodyPart[BodyPart["LEFT_UPPER_ARM"] = 16] = "LEFT_UPPER_ARM";
    BodyPart[BodyPart["RIGHT_UPPER_ARM"] = 17] = "RIGHT_UPPER_ARM";
    BodyPart[BodyPart["LEFT_HAND"] = 18] = "LEFT_HAND";
    BodyPart[BodyPart["RIGHT_HAND"] = 19] = "RIGHT_HAND";
    BodyPart[BodyPart["LEFT_SHOULDER"] = 20] = "LEFT_SHOULDER";
    BodyPart[BodyPart["RIGHT_SHOULDER"] = 21] = "RIGHT_SHOULDER";
    BodyPart[BodyPart["UPPER_CHEST"] = 22] = "UPPER_CHEST";
    BodyPart[BodyPart["LEFT_HIP"] = 23] = "LEFT_HIP";
    BodyPart[BodyPart["RIGHT_HIP"] = 24] = "RIGHT_HIP";
    BodyPart[BodyPart["LEFT_THUMB_METACARPAL"] = 25] = "LEFT_THUMB_METACARPAL";
    BodyPart[BodyPart["LEFT_THUMB_PROXIMAL"] = 26] = "LEFT_THUMB_PROXIMAL";
    BodyPart[BodyPart["LEFT_THUMB_DISTAL"] = 27] = "LEFT_THUMB_DISTAL";
    BodyPart[BodyPart["LEFT_INDEX_PROXIMAL"] = 28] = "LEFT_INDEX_PROXIMAL";
    BodyPart[BodyPart["LEFT_INDEX_INTERMEDIATE"] = 29] = "LEFT_INDEX_INTERMEDIATE";
    BodyPart[BodyPart["LEFT_INDEX_DISTAL"] = 30] = "LEFT_INDEX_DISTAL";
    BodyPart[BodyPart["LEFT_MIDDLE_PROXIMAL"] = 31] = "LEFT_MIDDLE_PROXIMAL";
    BodyPart[BodyPart["LEFT_MIDDLE_INTERMEDIATE"] = 32] = "LEFT_MIDDLE_INTERMEDIATE";
    BodyPart[BodyPart["LEFT_MIDDLE_DISTAL"] = 33] = "LEFT_MIDDLE_DISTAL";
    BodyPart[BodyPart["LEFT_RING_PROXIMAL"] = 34] = "LEFT_RING_PROXIMAL";
    BodyPart[BodyPart["LEFT_RING_INTERMEDIATE"] = 35] = "LEFT_RING_INTERMEDIATE";
    BodyPart[BodyPart["LEFT_RING_DISTAL"] = 36] = "LEFT_RING_DISTAL";
    BodyPart[BodyPart["LEFT_LITTLE_PROXIMAL"] = 37] = "LEFT_LITTLE_PROXIMAL";
    BodyPart[BodyPart["LEFT_LITTLE_INTERMEDIATE"] = 38] = "LEFT_LITTLE_INTERMEDIATE";
    BodyPart[BodyPart["LEFT_LITTLE_DISTAL"] = 39] = "LEFT_LITTLE_DISTAL";
    BodyPart[BodyPart["RIGHT_THUMB_METACARPAL"] = 40] = "RIGHT_THUMB_METACARPAL";
    BodyPart[BodyPart["RIGHT_THUMB_PROXIMAL"] = 41] = "RIGHT_THUMB_PROXIMAL";
    BodyPart[BodyPart["RIGHT_THUMB_DISTAL"] = 42] = "RIGHT_THUMB_DISTAL";
    BodyPart[BodyPart["RIGHT_INDEX_PROXIMAL"] = 43] = "RIGHT_INDEX_PROXIMAL";
    BodyPart[BodyPart["RIGHT_INDEX_INTERMEDIATE"] = 44] = "RIGHT_INDEX_INTERMEDIATE";
    BodyPart[BodyPart["RIGHT_INDEX_DISTAL"] = 45] = "RIGHT_INDEX_DISTAL";
    BodyPart[BodyPart["RIGHT_MIDDLE_PROXIMAL"] = 46] = "RIGHT_MIDDLE_PROXIMAL";
    BodyPart[BodyPart["RIGHT_MIDDLE_INTERMEDIATE"] = 47] = "RIGHT_MIDDLE_INTERMEDIATE";
    BodyPart[BodyPart["RIGHT_MIDDLE_DISTAL"] = 48] = "RIGHT_MIDDLE_DISTAL";
    BodyPart[BodyPart["RIGHT_RING_PROXIMAL"] = 49] = "RIGHT_RING_PROXIMAL";
    BodyPart[BodyPart["RIGHT_RING_INTERMEDIATE"] = 50] = "RIGHT_RING_INTERMEDIATE";
    BodyPart[BodyPart["RIGHT_RING_DISTAL"] = 51] = "RIGHT_RING_DISTAL";
    BodyPart[BodyPart["RIGHT_LITTLE_PROXIMAL"] = 52] = "RIGHT_LITTLE_PROXIMAL";
    BodyPart[BodyPart["RIGHT_LITTLE_INTERMEDIATE"] = 53] = "RIGHT_LITTLE_INTERMEDIATE";
    BodyPart[BodyPart["RIGHT_LITTLE_DISTAL"] = 54] = "RIGHT_LITTLE_DISTAL";
})(BodyPart = exports.BodyPart || (exports.BodyPart = {}));
